<div class="p-grid">
    <div class="p-col-12 page-header">Events Calendar</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="p-col-12 button-header">
        <div class="p-grid">
            <div class="p-col-12 p-lg-2 p-md-2">
                <p-button label="View Full Calendar" styleClass="fullwidthbtn" (click)="navUrl()"></p-button>
            </div>
            <div class="p-col-12 p-lg-4 p-md-4">
                <div class="event-help">
                    Submit Events to  <p-button label="help@naiglobal.com" styleClass="p-button-link" (click)="navMailto()"></p-button>
                    <a class="hyperLink" target="_blank" href="{{calendarwizURL}}">
                        <i class="pi pi-calendar-plus" style="font-size: 1.6rem;margin-left: 5px;color: #D03238;"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="p-col-12" *ngIf="events">
        <div class="card">
            <div id="dataListWrapper">
                <p-dataView #dv [value]="events" [paginator]="true" [rows]="1000" filterBy="title,eventmonth,category_name">                  
                    <ng-template let-event pTemplate="listItem">
                        <div class="p-col-12">
                            <div class="event-detail">
                                <div class="p-grid">
                                    <div class="p-col-3 p-lg-3 p-md-4">
                                        <div class="object-description event-month">{{event.eventmonth}}</div>
                                        <div class="object-description event-date">{{event.event_day}}</div>
                                        <div class="object-description event-day">{{event.dayOfWeek}}</div>
                                    </div>
                                    <div class="p-col-9 p-lg-7 p-md-5">
                                        <div class="object-description event-title">{{event.title}}</div>
                                        <div class="object-description event-body">
                                            {{event.starthour}}:{{event.startminute}}{{event.startampm}} - {{event.endhour}}:{{event.endminute}}{{event.endampm}}
                                        </div>
                                        <div class="object-description event-body"><strong>{{event.category_name}}</strong></div>
                                        <div class="object-description event-body"><strong>{{event.contact}}</strong></div>
                                    </div>
                                    <div class="p-col-12 p-lg-2 p-md-3">
                                        <p-button label="View Event" (click)="showViewEventDetailDialog(event)"></p-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft"></ng-template>
                    <ng-template pTemplate="paginatorright">
                        {{events != undefined ? events.length : 0}} result(s).
                    </ng-template>
                </p-dataView>
            </div>
        </div>
    </div>
</div>
<p-dialog draggable="false" modal="true"  *ngIf="selectedEvent" header="Event Details" [(visible)]="displayEventDetail" styleClass="p-dialog-medium" [baseZIndex]="10000" modal="true">
    <p-divider></p-divider>
    <div class="event-title">{{selectedEvent.title}}</div>
    <div class="event-body">
        {{selectedEvent.event_startdate}} {{selectedEvent.starthour}}:{{selectedEvent.startminute}}{{selectedEvent.startampm}} - {{selectedEvent.endhour}}:{{selectedEvent.endminute}}{{selectedEvent.endampm}}
    </div>
    <div class="event-description" *ngIf="selectedEvent.description.length > 0">
        <b>Description</b>:<div [innerHTML]="addStyle(selectedEvent.description)"></div>
    </div>
    <div class="event-description" *ngIf="selectedEvent.location_name.length > 0"><b>Location</b>: {{selectedEvent.location_name}}</div>
    <div class="event-description" *ngIf="selectedEvent.category_name.length > 0"><b>Category</b>: {{selectedEvent.category_name}}</div>
    <div class="event-description" *ngIf="selectedEvent.contact.length > 0">
        <b>Contact</b>: {{selectedEvent.contact}}
    </div>
    <div class="event-description" *ngIf="selectedEvent.email.length > 0">
        <b>Email</b>: <a class="hyperLink" href="mailto:{{selectedEvent.email}}"> {{selectedEvent.email}}</a>
    </div>
    <div class="event-description" *ngIf="selectedEvent.url.length > 0">
        <b>More Info:</b>
        <a class="hyperLink" href="{{selectedEvent.url}}" target="_blank"><b>{{selectedEvent.url}}</b></a>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Add To Calendar" styleClass="fullwidthbtn" (click)="addToCalendar()"></p-button>
        <p-button label="Close" styleClass="fullwidthbtn" (click)="closeViewEventDetailDialog()"></p-button>
    </ng-template>
</p-dialog>
